// ── series-preview-table: render the previewed (NOT-yet-created) sessions ───
// Wave 6 (Create Series). The preview response carries the previewed session
// instances in `row_results` (the non-write preview). We render them as a plain
// read-only table so the operator can review BEFORE confirming the create. No
// Zoom meeting/link is shown (none exists at preview time); nothing here implies
// a write happened.

import { CollectionPagination, DataTableV2 } from "@vjal/ui";

import type { CoachingOperationResult } from "../../../services/coaching-dtos";
import { toSeriesPreviewRows, useSeriesPreviewCollection } from "./series-preview-collection";

export function SeriesPreviewTable({ result }: { result: CoachingOperationResult | null }) {
  const rows = toSeriesPreviewRows(result);
  const collection = useSeriesPreviewCollection(rows);

  return (
    <div className="rounded-xl border border-line bg-white">
      <DataTableV2
        collection={collection}
        caption="Previewed sessions (not yet created)"
        emptyTitle="No sessions in this preview"
        emptyMessage="Adjust the start date/time and preview again."
      />
      {collection.uiState === "ready" && collection.total > collection.page.pageSize && (
        <CollectionPagination collection={collection} className="px-4" />
      )}
    </div>
  );
}